import axios from "axios";
import { API_URL } from "App";
const api = axios.create();

export const sendEmail = async (fname, lname, email, message) => {
  const fullName = fname + " " + lname;
  const response = await api.post(`${API_URL}/contact`, {
    fullName,
    email,
    message,
  });
  return response;
};
